import Component from '../core/Component';
export const STATUS = {
    ACTIVE: 'active'
}
export default class FilterArticles extends Component {

    constructor($element) {
        super($element);
        this.filterItems = $('.filter__items .filter__item')
        this.articles = $('.recent-articles__item');
    }

    prepare() {
        var filterItems = this.filterItems;
        var articles = this.articles;
        var articlesToShow = null;
        var toShow = null;

        for (var i = 0; i < filterItems.length; i++){

            filterItems.eq(i).on('click', function(){
                
                filterItems.removeClass('active');
                $(this).addClass('active');
                
                toShow = this.rel;
                
                articles.removeClass('visible');
                articles.addClass('hidden');

                if (toShow == 'all'){
                    articles.removeClass('hidden');
                    articles.addClass('visible');
                }
            
                for (var i = 0; i<articles.length; i++){
                    if (articles[i].rel == toShow){
                        articles.eq(i).removeClass('hidden');
                        articles.eq(i).addClass('visible');
                    }
                }

            })
        }   
    }

}


// WEBPACK FOOTER //
// ./components/FilterArticles.js